import { Immutable } from "immer";
import React from "react";

import { _RichNavigation__OfferLink as Value } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";
import { RichTextBlock } from "@thelabnyc/thelabui/src/components/RichText";
import { IntrinsicElementProps } from "@thelabnyc/thelabui/src/utils/types";

import { Flair } from "../Flair";

import styles from "./index.module.scss";

type Props = Immutable<{
    value: Value;
}> & {
    attrs?: IntrinsicElementProps<HTMLElement>;
};

export const RichNavigationOfferLink = (
    props: Props,
): React.JSX.Element | null => {
    // Render only if the offer is active and defined
    if (!props.value.offer) {
        return null;
    }
    const isActive =
        !props.value.promo_period || props.value.promo_period.is_promo_active;
    if (!isActive) {
        return null;
    }
    return (
        <a href={props.value.offer.url}>
            {props.value.flair && <Flair flair={props.value.flair} />}
            <RichTextBlock
                className={styles.text}
                value={props.value.text ?? ""}
            />
            {props.value.image && (
                <ImageChooserBlock
                    attrs={{ className: styles.img }}
                    value={props.value.image}
                />
            )}
        </a>
    );
};
